import { createSelector } from 'reselect';
import { TRANSPORT_ORDER_DOMAIN } from './constants';
import { initialState } from './reducer';

const selectTransportOrderDomain = state => state[TRANSPORT_ORDER_DOMAIN] || initialState;

export const selectTransportOrders = () => createSelector(selectTransportOrderDomain, d => d.transportOrders);

export const selectTransportOrder = id => createSelector(selectTransportOrderDomain, d => d.transportOrdersById[id]);

export const selectTransportOrderCount = () => createSelector(selectTransportOrderDomain, d => d.transportOrderCount);
export const selectTransportOrderPaginator = () => createSelector(selectTransportOrderDomain, d => d.paginator);

export const selectNewTransportOrderValue = name =>
  createSelector(selectTransportOrderDomain, d => d.newTransportOrder[name]);
export const selectNewTransportOrder = () => createSelector(selectTransportOrderDomain, d => d.newTransportOrder);

export const selectTransportOrderFilter = () => createSelector(selectTransportOrderDomain, d => d.filter);

export const selectFilterSingleValue = name =>
  createSelector(selectTransportOrderFilter, d => d?.properties?.find(f => f.key === name)?.value?.[0] ?? null);
export const selectFilterValues = name =>
  createSelector(selectTransportOrderFilter, d => d?.properties?.find(f => f.key === name)?.value ?? []);

export const selectTransportOrdersBulkActionsList = () =>
  createSelector(selectTransportOrderDomain, d => d.transportOrderBulkActionsList);

// Split, double view selectors
export const selectTransportOrdersSeparateList = () =>
  createSelector(selectTransportOrderDomain, d => d.transportOrdersSeparateList);
export const selectTransportOrderSeparateListFilter = () =>
  createSelector(selectTransportOrderDomain, d => d.separateListFilter);
export const selectSeparateListTransportOrderCount = () =>
  createSelector(selectTransportOrderDomain, d => d.separateListTransportOrderCount);
export const selectSeparateListTransportOrderPaginator = () =>
  createSelector(selectTransportOrderDomain, d => d.separateListPaginator);

export const selectOverviewScreenMode = () => createSelector(selectTransportOrderDomain, d => d.doubleScreenOverview);
export const selectQuickFilter = () => createSelector(selectTransportOrderDomain, d => d.filterCombination);
export const selectQuickSeparateFilter = () => createSelector(selectTransportOrderDomain, d => d.separateFilterCombination);
